(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["td-featured-collections"] && !Shopify.designMode) return;
  try {
    
  /**
   * TdSliderHeightSync
   *
   * Web component that syncs the --td-swiper-max-slide-height CSS variable
   * from the active slider to itself, allowing the feature card to match
   * the slider height.
   */
  class TdSliderHeightSync extends HTMLElement {
    constructor() {
      super();
      this.observer = null;
    }

    connectedCallback() {
      this.initObserver();
      this.syncHeight();
    }

    disconnectedCallback() {
      this.disconnectObserver();
    }

    /**
     * Initializes MutationObserver to watch for style changes on sliders
     * and attribute changes on tab panels (for tab switching).
     */
    initObserver() {
      const panelsContainer = this.querySelector('.td-tabbed-collections__panels');
      if (!panelsContainer) return;

      this.observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'data-tab-active') {
            this.syncHeight();
            return;
          }
          if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
            if (mutation.target.tagName && mutation.target.tagName.toLowerCase().includes('slider')) {
              this.syncHeight();
              return;
            }
          }
        }
      });

      this.observer.observe(panelsContainer, {
        attributes: true,
        attributeFilter: ['style', 'data-tab-active'],
        subtree: true,
      });
    }

    disconnectObserver() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
    }

    /**
     * Finds the active slider and syncs its height variable to this element.
     */
    syncHeight() {
      const activePanel = this.querySelector('.td-tabbed-collection[data-tab-active="true"]');
      if (!activePanel) return;

      const slider = activePanel.querySelector('[class*="slider"]');
      if (!slider) return;

      const height = getComputedStyle(slider).getPropertyValue('--td-swiper-max-slide-height');
      if (height && height.trim() !== '') {
        this.style.setProperty('--td-swiper-max-slide-height', height.trim());
      }
    }
  }

  if (!customElements.get('td-slider-height-sync')) {
    customElements.define('td-slider-height-sync', TdSliderHeightSync);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["td-main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["td-main-search"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["td-product-recommendations"] && !Shopify.designMode) return;
  try {
    
  /**
   * TdRecommendationsHeightSync
   *
   * Web component that syncs the --td-swiper-max-slide-height CSS variable
   * from the slider to itself, allowing the feature card to match
   * the slider height. Adapted for async content loading.
   */
  class TdRecommendationsHeightSync extends HTMLElement {
    constructor() {
      super();
      this.observer = null;
      this.handleReinitialize = this.handleReinitialize.bind(this);
    }

    connectedCallback() {
      this.initObserver();
      this.syncHeight();
      // Listen for swiper reinitialization after async content loads
      this.addEventListener('reinitialize-swiper', this.handleReinitialize, true);
    }

    disconnectedCallback() {
      this.disconnectObserver();
      this.removeEventListener('reinitialize-swiper', this.handleReinitialize, true);
    }

    /**
     * Handles the reinitialize-swiper event dispatched after async content loads.
     * Uses requestAnimationFrame to allow swiper to calculate heights first.
     */
    handleReinitialize() {
      requestAnimationFrame(() => this.syncHeight());
    }

    /**
     * Initializes MutationObserver to watch for style changes on sliders.
     */
    initObserver() {
      const panelsContainer = this.querySelector('.td-product-recommendations__panels');
      if (!panelsContainer) return;

      this.observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
            if (mutation.target.tagName?.toLowerCase().includes('slider')) {
              this.syncHeight();
              return;
            }
          }
        }
      });

      this.observer.observe(panelsContainer, {
        attributes: true,
        attributeFilter: ['style'],
        subtree: true,
      });
    }

    disconnectObserver() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
    }

    /**
     * Finds the slider and syncs its height variable to this element.
     */
    syncHeight() {
      const slider = this.querySelector('[class*="slider"]');
      if (!slider) return;

      const height = getComputedStyle(slider).getPropertyValue('--td-swiper-max-slide-height');
      if (height && height.trim() !== '') {
        this.style.setProperty('--td-swiper-max-slide-height', height.trim());
      }
    }
  }

  if (!customElements.get('td-recommendations-height-sync')) {
    customElements.define('td-recommendations-height-sync', TdRecommendationsHeightSync);
  }

  } catch(e) { console.error(e); }
})();
})();
